import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = anon, obj = logged
  const [notifCount, setNotifCount] = useState(0);

  const refreshNotifications = useCallback(async () => {
    try {
      const { data } = await api.get("/notifications");
      setNotifCount(data.unread || 0);
    } catch {
      setNotifCount(0);
    }
  }, []);

  const loadUser = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      refreshNotifications();
    } catch {
      setUser(false);
    }
  }, [refreshNotifications]);

  useEffect(() => {
    loadUser();
  }, [loadUser]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    refreshNotifications();
    return data;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    setUser(false);
    setNotifCount(0);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout, notifCount, refreshNotifications }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
